var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var MultiSelectModel = /** @class */ (function () {
    function MultiSelectModel(options, value, filter, filterFunction) {
        this._options = options;
        this._optionsFlat = this.flatMapOptions(options);
        this._value = value;
        this._filter = filter;
        this._filterFunction = filterFunction;
        this._optionsFiltered = this.getOptionsFiltered();
        this._optionsFilteredFlat = this.flatMapOptions(this._optionsFiltered);
        this._optionsEnabledFilteredFlat = this._optionsFilteredFlat.filter(function (opt) { return !opt.disabled; });
    }
    Object.defineProperty(MultiSelectModel.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiSelectModel.prototype, "filter", {
        get: function () {
            return this._filter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiSelectModel.prototype, "optionsFiltered", {
        get: function () {
            return this._optionsFiltered;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiSelectModel.prototype, "optionsFilteredFlat", {
        get: function () {
            return this._optionsFilteredFlat;
        },
        enumerable: false,
        configurable: true
    });
    MultiSelectModel.prototype.getOptionsFiltered = function () {
        var _this = this;
        var optionsFilteredCalcul = [];
        this._options.forEach(function (option) {
            if ("name" in option && "value" in option && _this._filterFunction(option, _this._filter)) {
                optionsFilteredCalcul.push(option);
            }
            else if ("options" in option) {
                var optionsFilteredOfGroup = option.options.filter(function (optionOfGroup) {
                    return _this._filterFunction(optionOfGroup, _this._filter);
                });
                if (optionsFilteredOfGroup.length > 0) {
                    if (option.disabled) {
                        optionsFilteredOfGroup = optionsFilteredOfGroup.map(function (optionOfGroup) {
                            return __assign(__assign({}, optionOfGroup), { disabled: true });
                        });
                    }
                    optionsFilteredCalcul.push(__assign(__assign({}, option), { options: optionsFilteredOfGroup }));
                }
            }
        });
        return optionsFilteredCalcul;
    };
    MultiSelectModel.prototype.flatMapOptions = function (options) {
        return options.flatMap(function (option) {
            if ("options" in option) {
                return option.options;
            }
            return [option];
        });
    };
    MultiSelectModel.prototype.getNumberOfOptionsSelectedLabel = function () {
        var _this = this;
        if (!this._value || this._value.length === 0) {
            return undefined;
        }
        var optionMultiSelectedResult = this._optionsFlat.filter(function (option) { return _this._value.includes(option.value); });
        if (!optionMultiSelectedResult)
            return undefined;
        if (optionMultiSelectedResult.length === 1) {
            return optionMultiSelectedResult[0].name ? optionMultiSelectedResult[0].name : "1 option sélectionné";
        }
        return optionMultiSelectedResult.length + " options sélectionnées";
    };
    MultiSelectModel.prototype.hasAllFilteredOptionsSelected = function () {
        var _this = this;
        var optionFilteredSelected = this._optionsEnabledFilteredFlat.filter(function (opt) {
            return _this._value.includes(opt.value);
        });
        return optionFilteredSelected.length === this._optionsEnabledFilteredFlat.length;
    };
    MultiSelectModel.prototype.selectAllFilteredOptions = function () {
        var valueToSelect = this._optionsEnabledFilteredFlat.map(function (opt) { return opt.value; });
        return __spreadArray(__spreadArray([], this._value, true), valueToSelect, true);
    };
    MultiSelectModel.prototype.unselectAllFilteredOptions = function () {
        var valueToUnselect = this._optionsEnabledFilteredFlat.map(function (opt) { return opt.value; });
        return this._value.filter(function (val) { return !valueToUnselect.includes(val); });
    };
    MultiSelectModel.prototype.toggleOption = function (newValue) {
        var _this = this;
        if (this._value.includes(newValue)) {
            return this._value.filter(function (val) { return val !== newValue; });
        }
        return this._optionsFlat
            .filter(function (opt) { return _this._value.includes(opt.value) || opt.value === newValue; })
            .map(function (opt) { return opt.value; });
    };
    MultiSelectModel.prototype.optionIsSelected = function (optionValue) {
        return this._value.includes(optionValue);
    };
    return MultiSelectModel;
}());
export default MultiSelectModel;
